export default __webpack_public_path__ + "static/media/Q6_3.75ff0b27.png";